<div class="col-lg-11 border-bx" *ngIf="airlinesFetched">
    <img src="../../../../assets/loader/loader_plane_light.gif">
</div>
